import seasonHistories from "@/api/season-histories";
import seasons from "@/api/seasons";

export default {
  state: {
    seasonHistories: []
  },
  mutations: {
    ["RETRIEVE_SEASON_HISTORIES"](state, data) {
      state.seasons = data;
    }
  },
  actions: {
    async retrieveSeasonHistories(context, { management_id }) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
          management_id: await context.dispatch("showManagementID"),
          include_outof_paddy_field_item: true
        };
        let res;
        if (management_id != params.management_id) {
          // 過去のマスタデータ取得
          params.management_id = management_id;
          res = await seasonHistories.index(params);
        }
        else {
          // 現在のマスタデータ取得
          res = await seasons.index(params);
        }
        context.commit("RETRIEVE_SEASON_HISTORIES", res.data.data);
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    getSeasonHistories(state) {
      return state.seasonHistories;
    }
  }
};
